import React, { useEffect, useRef, useState } from 'react';
import { mountCourse } from '../vendor/kursus-foraeldreansvarsloven/player.js';
import { mountReport } from '../vendor/kursus-foraeldreansvarsloven/report.js';
import { COURSE }      from '../vendor/kursus-barnetslov/content.js';
import '../vendor/kursus-foraeldreansvarsloven/player.css';

const API_BASE = '/api/training';

const FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300..900;1,9..144,300..900&family=Instrument+Sans:wght@400;500;600&family=Clicker+Script&display=swap';

function injectFonts() {
  if (document.getElementById('fak-fonts')) return;
  const link = document.createElement('link');
  link.id   = 'fak-fonts';
  link.rel  = 'stylesheet';
  link.href = FONTS_HREF;
  document.head.appendChild(link);
}

function KursusAfspiller({ bruger }) {
  const ref = useRef(null);

  useEffect(() => {
    injectFonts();
    if (!ref.current) return;
    const instance = mountCourse(ref.current, {
      course:    COURSE,
      apiBase:   API_BASE,
      user:      { id: String(bruger?.id ?? ''), name: bruger?.navn ?? '' },
      theme:     'auto',
      fetchInit: { credentials: 'include' },
      onComplete: (score) => {
        console.info('[kursus-barnetslov] gennemført', score);
      },
    });
    return () => instance?.destroy?.();
  }, [bruger]);

  return <div ref={ref} style={{ minHeight: '80vh' }} />;
}

function KursusRapport() {
  const ref = useRef(null);

  useEffect(() => {
    injectFonts();
    if (!ref.current) return;
    const instance = mountReport(ref.current, {
      course:    COURSE,
      apiBase:   API_BASE,
      fetchInit: { credentials: 'include' },
    });
    return () => instance?.destroy?.();
  }, []);

  return <div ref={ref} style={{ minHeight: '80vh' }} />;
}

export default function KursusBarnetslov({ bruger, onTilbage }) {
  const erAdmin = bruger?.os_admin;
  const [fane, setFane] = useState(erAdmin ? 'rapport' : 'kursus');

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: '24px 16px' }}>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
        <button
          onClick={onTilbage}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: 22, lineHeight: 1, padding: 4 }}
          aria-label="Tilbage"
        >←</button>
        <div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#f1f5f9' }}>
            Barnets lov § for §
          </div>
          <div style={{ fontSize: 13, color: '#94a3b8', marginTop: 2 }}>
            LBK nr. 642 af 1. juli 2026 · 25 kapitler · §§ 1-214
          </div>
        </div>

        {erAdmin && (
          <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
            {[
              { id: 'kursus',  label: '📖 Tag kursus' },
              { id: 'rapport', label: '📊 Lederrapport' },
            ].map(f => (
              <button
                key={f.id}
                onClick={() => setFane(f.id)}
                style={{
                  padding: '8px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer',
                  border: fane === f.id ? 'none' : '1px solid rgba(255,255,255,0.1)',
                  background: fane === f.id ? '#3fd4c7' : 'rgba(255,255,255,0.05)',
                  color: fane === f.id ? '#0a0e2e' : '#94a3b8',
                  transition: 'all 0.15s',
                }}
              >{f.label}</button>
            ))}
          </div>
        )}
      </div>

      {fane === 'kursus'  && <KursusAfspiller bruger={bruger} />}
      {fane === 'rapport' && erAdmin && <KursusRapport />}
    </div>
  );
}
